var map = {
	"./dashboard.jpg": 64352,
	"./featured_img_one.jpg": 5676,
	"./featured_img_two.jpg": 87957,
	"./feedback_img_one.png": 86826,
	"./feedback_img_three.png": 46062,
	"./feedback_img_two.png": 99664,
	"./logo_01.png": 42155,
	"./logo_02.png": 32026,
	"./logo_03.png": 74076,
	"./logo_04.png": 395,
	"./logo_05.png": 96453,
	"./shape-1.png": 32344,
	"./shape2.png": 58208,
	"./trust_img.png": 12733,
	"./trust_img2.png": 3817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25973;